"use client";

import React from "react";
import { MapPin, Phone, Mail, Facebook, Linkedin, Twitter, Youtube, Send, Loader } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function NewsletterFormContent() {
  const {
    control,
    handleSubmit,
    isSubmitting,
    isSubmitted,
    successMessage
  } = useWvcForm();
  if (isSubmitted) {
    return <div className="p-4 rounded-md bg-primary/10 border border-primary/20 text-primary text-sm">
        {successMessage}
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-2">
      <div className="flex gap-2">
        <FormField control={control} name="email" rules={{
        required: "Email là bắt buộc",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Địa chỉ email không hợp lệ"
        }
      }} render={({
        field
      }) => <FormItem className="flex-1">
              <FormControl>
                <Input placeholder="Nhập email của bạn" className="bg-background/5 border-primary/20 focus-visible:ring-primary/50 text-foreground placeholder:text-muted-foreground/70 h-10" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <Button type="submit" size="icon" disabled={isSubmitting} className="bg-primary hover:bg-primary/90 text-primary-foreground h-10 w-10 shrink-0">
          {isSubmitting ? <Loader className="size-4 animate-spin" /> : <Send className="size-4" />}
          <span className="sr-only">Subscribe</span>
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Đăng ký để nhận cập nhật về các công nghệ và dự án mới nhất của chúng tôi.
      </p>
    </Form>;
}
function NewsletterSection() {
  return <FormProvider formId="footer-newsletter" sectionName="footer" defaultValues={{
    email: ""
  }} submitText="Đăng ký" successMessage="Cảm ơn bạn đã đăng ký!" className="w-full">
      <NewsletterFormContent />
    </FormProvider>;
}
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-2">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted/10 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackLinks = [{
      label: "Giới thiệu",
      href: "/AboutUsPage"
    }, {
      label: "Giải pháp",
      href: "/SolutionsPage"
    }, {
      label: "Tin tức",
      href: "/NewsPage"
    }, {
      label: "Đối tác",
      href: "/CompanyPartnerPage"
    }];
    return <ul className="space-y-2">
        {fallbackLinks.map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-muted-foreground hover:text-primary transition-colors text-sm block py-1">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-2">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm block py-1">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function FooterLinks() {
  return <MenuProvider menu_id="87" className="w-full">
      <FooterMenuConsumer />
    </MenuProvider>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Youtube,
    href: "https://youtube.com",
    label: "YouTube"
  }];
  return <footer id="footer" className="dark bg-background text-foreground border-t border-primary/20">
      <div className="container mx-auto px-4 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {}
          <div className="space-y-6">
            <Link to="/" className="block">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              NUCETECH là tổ chức nghiên cứu chuyên sâu về chuyển giao công nghệ, đổi mới sáng tạo và tư vấn chuyển đổi số cho ngành xây dựng. Chúng tôi tận dụng chuyên môn từ Trường Đại học Xây dựng Hà Nội để cung cấp các giải pháp kỹ thuật tiên tiến.
            </p>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-foreground tracking-tight">Liên kết nhanh</h3>
            <FooterLinks />
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-foreground tracking-tight">Liên hệ với chúng tôi</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
                <span>Hà Nội, Việt Nam</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="size-5 text-primary shrink-0" />
                <Link to="tel:+842412345678" className="hover:text-primary transition-colors">
                  +84 24 1234 5678
                </Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="size-5 text-primary shrink-0" />
                <Link to="mailto:contact@nucetech.vn" className="hover:text-primary transition-colors">
                  contact@nucetech.vn
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-foreground tracking-tight">Bản tin</h3>
            <p className="text-sm text-muted-foreground">
              Cập nhật thông tin về các nghiên cứu và đổi mới công nghệ xây dựng mới nhất của chúng tôi.
            </p>
            <NewsletterSection />
          </div>
        </div>
      </div>

      
    </footer>;
}